import React from "react";
import { Doughnut } from "react-chartjs-2";
import type { TooltipItem } from "chart.js";

interface LineSeries {
  labels: string[];
  datasets: {
    data: number[];
    backgroundColor: string[];
  }[];
}

const labelTooltip = (tooltipData: TooltipItem<"doughnut">): string => {
  const label = tooltipData.label ? tooltipData.label.trim() : "";
  const value = tooltipData.formattedValue || 0;
  return `${label}: ${value} Patients`;
};

const doughnutOptions = {
  cutout: "75%",
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: labelTooltip,
      },
    },
  },
};

export default function BreakdownByGender({ data }: { data: LineSeries }) {
  return <Doughnut data={data} options={doughnutOptions} />;
}
